










import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class RadioButton extends Vue  implements Components.IControl {

  @Prop({default:''}) public title?: string;
  @Prop({default:null}) public value?: any;
  @Prop({default:''}) public list?: string;
  @Prop() public tooltip: string;
  @Prop({default:null}) public editor :Components.IEditor;
  @Prop({default:true}) public enabled: boolean;
  @Prop({ default: true }) public isDirectEditEnabled: boolean;    
  @Prop({ default: 1 }) public rows: number;
  @Prop({ default: 0 }) public disabled: number;  //特定の値を非活性表示
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null ;

  created(){
    this.validator = new Components.ControlValidator(this, 'tooltip', ()=>'');    
    if (this.editor != null) this.editor.addControl(this);
  }
  destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }

  public get selected(): any {
    return this.value;
  }

  public set selected(value: any) {
    // 親コンポーネント側で更新
    this.$emit('update:value', value);
  }

  public get selectedText(): string {
    for (const option of this.$api.formatter.getOptions(this.list)) {
      if (option.value === this.value) {
        return option.text;
      }
    }
    return '';
  }

  public get options(): any {
    const results: any[] = new Array();
    for (const option of this.$api.formatter.getOptions(this.list)) {
      results.push({ text: option.text, value: option.value });
    }
    return results;
  }
}
